import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {StorageService} from '../../../../_services/storage.service';

@Component({
  selector: 'app-why-about-you',
  templateUrl: './about-you.component.html',
  styleUrls: ['./about-you.component.scss']
})

export class AboutYouComponent implements OnInit {
  aboutYouForm: FormGroup;
  submitted = false;

  constructor(private router: Router,
              private storageService: StorageService) {
    this.aboutYouForm = new FormGroup({
      age: new FormControl('',
        [
          Validators.required,
        ]),
      postcode: new FormControl('', []),
      gender: new FormControl('', []),
      describeGender: new FormControl('', []),
      occupation: new FormControl('', [])
    });
  }

  get field(): any {
    return this.aboutYouForm.controls;
  }

  ngOnInit(): void {
    if (this.aboutYouForm.get('gender').value === '') {
      this.aboutYouForm.get('gender').patchValue('not_say');
    }
  }

  async onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.aboutYouForm.invalid) {
      return;
    }
    const profileObj = {
      age: this.aboutYouForm.value.age,
      postCode: this.aboutYouForm.value.postcode,
      gender: this.aboutYouForm.value.gender,
      describeGender: this.aboutYouForm.value.describeGender,
      occupation: this.aboutYouForm.value.occupation,
    };
    const userObj = await this.storageService.get(environment.userObj);
    userObj.profileObj = {...profileObj};
    await this.storageService.set(environment.userObj, userObj);
    await this.router.navigate(['./user/auth/final-bit']);
  }

  didScroll(scroll) {
  }
}
